export default {
      id: "menu-open-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#menu-open",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu-open.svg
// module id = 135
// module chunks = 241 242 243